export default __webpack_public_path__ + "static/media/logo1.e2426446.png";